import { supabaseServer } from '@/lib/supabase.server';
import type { EmailOtpType } from '@supabase/supabase-js';
import { createServerFn } from '@tanstack/react-start';

export const verifyAuthLink = createServerFn({ method: 'POST' })
  .inputValidator((d: { token_hash?: string; type?: EmailOtpType; code?: string }) => d)
  .handler(async ({ data }) => {
    const supabase = supabaseServer();

    // token_hash-links (mailtemplate) werken op elk apparaat. De `code` is de
    // PKCE-fallback voor links uit de standaardtemplate en werkt alleen in de
    // browser waarin de reset is aangevraagd.
    if (data.token_hash && data.type) {
      const { error } = await supabase.auth.verifyOtp({
        token_hash: data.token_hash,
        type: data.type,
      });
      return { error: !!error };
    }

    if (data.code) {
      const { error } = await supabase.auth.exchangeCodeForSession(data.code);
      return { error: !!error };
    }

    return { error: true };
  });
